import React from "react";
import "./index.css";
import man from "../../../assets/media/img/quote-img.svg";
import quote from "../../../assets/media/img/quote.svg";
const Quote = () => {
  return (
    <section className="sectionn | md:py-94px md:px-30px | pt-[135px] py-64px px-20px bg-primary-50 md:pb-0 pb-0">
      <div className="section-containerr quote  | flex justify-between items-center m-auto max-w-[1560px] | md:flex-row md:gap-64px md:pb-94px | flex-col gap-48px  pb-64px">
        <div className="left | flex">
          <img className="max-w-[330px] w-full" src={man} alt="" />
        </div>
        <div className="right | flex flex-col gap-20px">
          <img className="max-w-[30px] w-full" src={quote} alt="" />
          <p className="m-0 text-primary-900 max-w-[600px] font-light | md:text-4xl md:leading-[140%] | text-3xl leading-[130%]">
            Embrace challenges, celebrate victories, and strive towards your
            goals. Every step shapes who you become on life's journey.
          </p>
          <div className="name | font-bold uppercase text-lg text-primary-900">
            <span className="me-10px">—</span>JADA Mohamed
          </div>
        </div>
      </div>
    </section>
  );
};
export default Quote;
